import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { IntlProps } from '../../../../';
import { Table } from '../../../../components';
import { selectAllTickers, selectCurrentTicker, selectGroupTickers } from '../../../../modules/public/tickers/selector';
import { setCurrentTicker } from '../../../../modules/public/tickers/actions';

const MarketsListComponent: React.FC<{ search: string; currencyQuote: string } & IntlProps> = ({ search, intl }) => {
    const dispatch = useDispatch();
    const currentTicker = useSelector(selectCurrentTicker);
    const groupTickers = useSelector(selectGroupTickers);
    const tickersInfo = useSelector(selectAllTickers);
    const getHeaders = () => [<span>Ticker</span>, <span>Organ Name</span>];
    const mapGroupTickers = useMemo(() => {
        return groupTickers
            .filter((item) => item.toLowerCase().includes(search.toLowerCase()))
            .map((ticker) => {
                const tickerInfo = tickersInfo[ticker] || { ticker: '', organ_name: '' };
                return [tickerInfo.ticker, tickerInfo.organ_name];
            });
    }, [groupTickers, tickersInfo, search]);

    const handleSelectRow = (key: string) => {
        // console.log(setCurrentTicker(tickersInfo[key]));
        dispatch(setCurrentTicker(tickersInfo[key]));
    };

    const data = mapGroupTickers;

    return (
        <div className="pg-dropdown-markets-list-container">
            {data.length > 0 && (
                <Table
                    data={data}
                    header={getHeaders()}
                    onSelect={handleSelectRow}
                    selectedKey={currentTicker?.ticker}
                    rowKeyIndex={0}
                />
            )}
        </div>
    );
};

export const MarketsList = injectIntl(MarketsListComponent);
